<script>
    import CreateBackupView from "./BackupModalViews/CreateBackupView";
    import DeployBackupView from "./BackupModalViews/DeployBackupView";
    import DestroyBackupView from "./BackupModalViews/DestroyBackupView";

    export default {
        props: {
            regions: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                selectedBackup: undefined,
                modalData: {
                    show: false,
                    component: undefined,
                    componentProps: {}
                }
            };
        },
        methods: {
            showCreatePopUp() {
                this.modalData.componentProps = {};
                this.modalData.component = CreateBackupView;
                this.modalData.show = true;
            },
            showDeployPopUp(backupId) {
                this.modalData.componentProps = {backup: backupId, regions: this.regions};
                this.modalData.component = DeployBackupView;
                this.modalData.show = true;
            },
            showDestroyPopUp(fileName) {
                if (!confirm('Are you sure?')) {
                    return;
                }

                this.modalData.componentProps = {fileName: fileName, regions: this.regions};
                this.modalData.component = DestroyBackupView;
                this.modalData.show = true;
            },
            closeModal() {
                this.modalData.show = false;
                this.modalData.component = undefined;
                this.modalData.componentProps = {};
            }
        }
    };
</script>

<style lang="scss" scoped>
    .controls {
        display: flex;
        justify-content: flex-end;
        padding: 0.75rem;
    }
</style>
